import Small from 'UIComponents/elements/Small';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UILink from 'UIComponents/link/UILink';
import { getUserWorkingHoursURL } from '../../working-hours/utils/workingHoursUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { useOutOfOfficeHours } from '../../working-hours/hooks/useOutOfOfficeHours';
import { jsx as _jsx } from "react/jsx-runtime";
export const OutOfOfficeLabel = ({
  userId
}) => {
  const {
    currentSegment
  } = useOutOfOfficeHours(userId, {
    isViewingSelf: true
  });
  if (currentSegment) {
    const {
      startTimestamp,
      endTimestamp
    } = currentSegment;
    return /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "routing-ui.agent-status.outOfOfficeTooltip",
        options: {
          startDate: /*#__PURE__*/_jsx(FormattedDateTime, {
            type: "userTz",
            value: startTimestamp,
            format: "short-date"
          }),
          startTime: /*#__PURE__*/_jsx(FormattedDateTime, {
            type: "userTz",
            value: startTimestamp,
            format: "LT"
          }),
          endDate: /*#__PURE__*/_jsx(FormattedDateTime, {
            type: "userTz",
            value: endTimestamp,
            format: "short-date"
          }),
          endTime: /*#__PURE__*/_jsx(FormattedDateTime, {
            type: "userTz",
            value: endTimestamp,
            format: "LT"
          }),
          link: /*#__PURE__*/_jsx(UILink, {
            className: "nowrap",
            href: getUserWorkingHoursURL(userId),
            external: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "routing-ui.agent-status.manageOutOfOfficeHoursLink"
            })
          })
        }
      }),
      children: /*#__PURE__*/_jsx(Small, {
        className: "p-left-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.agent-status.outOfOffice"
        })
      })
    });
  }
  return null;
};
OutOfOfficeLabel.displayName = 'OutOfOfficeLabel';